document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product_info_main').forEach(function(prodInfo) {
        const tabs = prodInfo.querySelectorAll('.prod_info_tab_title');
        const contents = prodInfo.querySelectorAll('.prod_info_info_item');
        const slider = prodInfo.querySelector('.tab_slider');

        // Set initial position WITHOUT transition
        const activeTab = document.querySelector('.prod_info_tab_title.active');
        if (activeTab) {
            slider.style.transition = 'none';
            slider.style.width = `${activeTab.offsetWidth}px`;
            slider.style.left = `${activeTab.offsetLeft}px`;

            if (activeTab.offsetLeft === 0) {
                slider.style.borderRadius = '0 0 0 18px';
            } else {
                slider.style.borderRadius = '0 0 18px 0';
            }
            // Enable transition after a tiny delay
            setTimeout(() => {
                slider.style.transition = 'left 0.3s ease, width 0.3s ease';
            }, 50);
        }

        const moveSlider = (tab) => {
            slider.style.width = `${tab.offsetWidth}px`;
            slider.style.left = `${tab.offsetLeft}px`;
            if (tab.offsetLeft === 0) {
                slider.style.borderRadius = '0 0 0 18px';
            } else {
                slider.style.borderRadius = '0 0 18px 0';
            }
        };

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                tabs.forEach((t, i) => {
                    t.classList.toggle('active', i === index);
                    contents[i].classList.toggle('active', i === index);
                });
                moveSlider(tab);
            });
        });

        window.addEventListener('resize', () => {
            const currentTab = prodInfo.querySelector('.prod_info_tab_title.active');
            if (currentTab) moveSlider(currentTab);
        });
    });
});



// document.addEventListener('DOMContentLoaded', function() {
//   const tabTitles = document.querySelectorAll('.prod_info_tab_title');
//   const tabContents = document.querySelectorAll('.prod_info_info_item');

//   tabTitles.forEach((tab, index) => {
//     tab.addEventListener('click', function() {
//       // Remove active class from all tabs
//       tabTitles.forEach(t => t.classList.remove('active'));
//       tabContents.forEach(c => c.classList.remove('active'));

//       // Add active class to clicked tab and corresponding content
//       tab.classList.add('active');
//       if(tabContents[index]) {
//         tabContents[index].classList.add('active');
//       }
//     });
//   });
// });